import ApplicationAdapter from 'eflex/adapters/application';

export default class CognexCameraAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
